import styled from 'styled-components';
import { createShouldForwardProp } from '../../helpers/createShouldForwardProp';
import { black16, purpleAlpha8, white } from '../../styles/colors';
import { compose, createPropTypes, flexbox, margin, padding } from '../../styles/system';
import { unit } from '../../styles/unit';
const styleProps = compose(flexbox, margin, padding).withDefaults({
  flexDirection: 'column',
  py: 6,
  px: 6
});
const shouldForwardProp = createShouldForwardProp(styleProps.propNames);
const Section = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp
}).withConfig({
  displayName: "Section",
  componentId: "sc-1bwvbwb-0"
})(["display:flex;width:100%;border-radius:", ";background-color:", ";box-shadow:0px 0px 12px ", ",0px 0px 6px ", ",0px 0px 3px ", ";", ""], unit(2), white, purpleAlpha8, purpleAlpha8, purpleAlpha8, styleProps);
Section.propTypes = createPropTypes(styleProps.propNames);
const SectionSeparator = /*#__PURE__*/styled.hr.attrs(props => ({
  role: props.role || 'separator'
})).withConfig({
  displayName: "SectionSeparator",
  componentId: "sc-1bwvbwb-1"
})(["display:block;border:0;border-bottom:solid 1px ", ";", ""], black16, margin.withDefaults({
  my: 8,
  mx: -6
}));
SectionSeparator.propTypes = createPropTypes(margin.propNames);
export { Section, SectionSeparator };